import {createStateMaker} from '@shared/helpers/object'

import {ReceiverInfoState} from '../interfaces'

export const getInitialState = (): ReceiverInfoState => ({
    receiverName: '',
    phoneNumber: '',
    autofillPhoneNumber: '',
    usedAutofill: false,
    isBarcodeConnectedEcouponProductContained: false,
})

export const makeMock = createStateMaker<ReceiverInfoState>(getInitialState)
